import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  loadLessonDetail,
  deleteLesson,
  clearLessonDetail,
  addFavoriteLesson,
  loadRelatedLessons,
  clearRelatedLessons,
  showHomeworkForm,
  hideHomeworkForm,
} from '../../common/lessons/actions'
import { OpenQuestionForm, OptionsForm, TranslationForm } from '../forms'
import { roles, exerciseTypes } from '../../common/config'
import { Button, PageHeader, LessonButtons, Tag,
  WordboxDetail, BackLink } from '../components'

import HomeworkPopup from '../components/HomeworkPopup'

class LessonDetailPage extends React.Component {
  state = {
    showHomeworkPopup: false,
  }

  componentDidMount() {
    const { loadLessonDetail, loadRelatedLessons, match, loadingLesson } = this.props
    if (!loadingLesson && match && match.params.id) {
      loadLessonDetail(match.params.id)
      // loadRelatedLessons(match.params.id)
    }
  }

  componentDidCatch(error, info) {
    console.log('error - LessonDetailPage')
    console.log(error)
    console.log('info')
    console.log(info)
  }

  componentDidUpdate() {
    const { currentLesson, match, loadLessonDetail,
      loadRelatedLessons, loadingLesson } = this.props
    const paramId = match && match.params.id 

    if (!loadingLesson && (currentLesson && currentLesson.id !== paramId)) {
      console.log('reloading lesson')
      loadLessonDetail(paramId)
      loadRelatedLessons(paramId)      
    }
  }

  componentWillUnmount() {
    this.props.clearLessonDetail()
    this.props.clearRelatedLessons()
    // this.props.hideHomeworkForm()
  }

  onDelete(lessonID) {
    this.props.deleteLesson(lessonID)
  }

  print() {
    window.print()
    return false
  }

  render() {
    const { viewer, currentLesson, addFavoriteLesson, isPopup, lessons,
      clearLessonDetail, intl, isTestForm, showHomeworkForm, relatedLessons,
      hideHomeworkForm, visibleHomeworkForm } = this.props
    
    const { showHomeworkPopup } = this.state

    if (!currentLesson) return null

    const allLessons = lessons && lessons.toJS()
    const isSaved = allLessons && allLessons.find(l => l.id === currentLesson.id)

    return (
      <div className={isPopup ? '' : 'page'}>
        <div className="flex-column width-full">
          {
            isPopup ?
              <header>
                <div
                  className="popup-wrapper-close"
                  onClick={() => clearLessonDetail()}
                >
                  <FontAwesomeIcon icon="times-circle" size="2x" />
                </div>
              </header>
            :
              <BackLink />
          }
          <div className={isPopup ? 'popup-content-body' : 'width-full'}>
            <PageHeader
              title={`${intl.formatMessage(messages.exercise)}: ${currentLesson.name}`}
              share={`https://vobo.io/lessons/${currentLesson.id}`}
            />
            {
              viewer && viewer.role === roles.TEACHER &&
              currentLesson.type === exerciseTypes.TRANSLATION &&
              <p className="instructions-to-study">
                {intl.formatMessage(messages.learnAccess)}: <a href={`https://vobo.io/vocabulary-learn/${currentLesson.id}`}><b>vobo.io/vocabulary-learn/{currentLesson.id}</b></a>
              </p>
            }
            {
              currentLesson.type === exerciseTypes.OPTIONS &&
              <OptionsForm
                lesson={currentLesson}
                isDetailPage
              />
            }
            {
              currentLesson.type === exerciseTypes.OPEN_QUESTION &&
              <OpenQuestionForm
                lesson={currentLesson}
                isDetailPage
              />
            }
            {
              currentLesson.type === exerciseTypes.TRANSLATION &&
              <React.Fragment>
                <div className="lesson-action-links">
                  <Link
                    className="lesson-action-links-link"
                    to={`/vocabulary-learn/${currentLesson.id}`}
                  >
                    <FontAwesomeIcon icon="graduation-cap" size="3x" />
                    <p>{intl.formatMessage(messages.study)}</p>
                  </Link>
                  <Link
                    className="lesson-action-links-link"
                    to={`/app/practice/${currentLesson.id}`}
                  >
                    <FontAwesomeIcon icon="align-left" size="3x" />
                    <p>{intl.formatMessage(messages.test)}</p>
                  </Link>
                  <Link className="lesson-action-links-link" to="#" onClick={() => this.print()}>
                    <FontAwesomeIcon icon="print" size="3x" />
                    <p>{intl.formatMessage(messages.print)}</p>
                  </Link>
                </div>
                <TranslationForm
                  lesson={currentLesson}
                  isDetailPage
                />
              </React.Fragment>
            }
            {
              currentLesson.type === exerciseTypes.WORDBOX &&
              <WordboxDetail
                lesson={currentLesson}
                isDetailPage
              />
            }
            {
              isTestForm && !isSaved &&
              <Button
                className="disable-spacing-left"
                onClick={() => {
                  addFavoriteLesson(currentLesson.id)
                  clearLessonDetail()
                }}
                positive
              >
                {intl.formatMessage(messages.addToTest)}
              </Button>
            }
            {
              viewer ?
                <LessonButtons
                  viewer={viewer}
                  lesson={currentLesson}
                  addFavoriteLesson={addFavoriteLesson}
                />
              :
                !isTestForm &&
                <Button
                  big
                  positive
                  className="disable-spacing-left spacing-top"
                  onClick={() => showHomeworkForm()}
                >
                  {intl.formatMessage(messages.createHomework)}
                </Button>
            }
            {
              visibleHomeworkForm &&
              <HomeworkPopup />
            }
            {
              !!relatedLessons.length &&
              <div className="related-lessons">
                <h3>
                  {intl.formatMessage(messages.relatedLessons)}
                </h3>
                <div className="related-lessons-list">
                  {
                    relatedLessons.map(rl => (
                      <Link
                        key={rl.id}
                        to={`/lessons/${rl.id}`}
                        className="related-lessons-list-item"
                      >
                        <img src={`/assets/icons/${rl.type}2.png`} />
                        <h3>{rl.name}</h3>
                        <div>
                          {
                            rl.tags.slice(0, 1).map(tag => <Tag key={tag.id} tag={tag} small />)
                          }
                        </div>
                      </Link>
                    ))
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

LessonDetailPage.defaultProps = {
  currentLesson: null,
  match: null,
  viewer: null,
  isPopup: false,
  relatedLessons: [],
}

LessonDetailPage.propTypes = {
  intl: PropTypes.object.isRequired,
  loadLessonDetail: PropTypes.func.isRequired,
  deleteLesson: PropTypes.func.isRequired,
  clearLessonDetail: PropTypes.func.isRequired,
  addFavoriteLesson: PropTypes.func.isRequired,
  showHomeworkForm: PropTypes.func.isRequired,
  hideHomeworkForm: PropTypes.func.isRequired,
  loadRelatedLessons: PropTypes.func.isRequired,
  relatedLessons: PropTypes.array,
  currentLesson: PropTypes.object,
  match: PropTypes.object,
  viewer: PropTypes.object,
  isPopup: PropTypes.bool,
}

const enhance = compose(
  connect(state => ({
    appRoute: state.app.changedRoute,
    viewer: state.users.viewer,
    lessons: state.lessons.all,
    currentLesson: state.lessons.currentLesson,
    loadingLesson: state.lessons.loadingLesson,
    relatedLessons: state.lessons.relatedLessons,
    visibleHomeworkForm: state.lessons.visibleHomeworkForm,
  }), { loadLessonDetail, deleteLesson, clearLessonDetail,
    addFavoriteLesson, showHomeworkForm, hideHomeworkForm,
    loadRelatedLessons, clearRelatedLessons }),
  injectIntl,
)

const EnhancedLessonDetailPage = enhance(LessonDetailPage)

EnhancedLessonDetailPage.fetchData = [{
  action: loadLessonDetail, lastPart: true, default: 0
}]

export default EnhancedLessonDetailPage

const messages = defineMessages({
  exercise: {
    id: 'lessonDetail.page.exercise',
    defaultMessage: 'Cvičenie',
  },
  study: {
    id: 'lessonDetail.page.study',
    defaultMessage: 'Učiť sa',
  },
  test: {
    id: 'lessonDetail.page.test',
    defaultMessage: 'Test',
  },
  memoryGame: {
    id: 'lessonDetail.page.memoryGame',
    defaultMessage: 'Pexeso',
  },
  print: {
    id: 'lessonDetail.page.print',
    defaultMessage: 'Vytlačiť',
  },
  learnAccess: {
    id: 'lessonDetail.page.learnAccess',
    defaultMessage: 'Žiaci sa môžu učiť slovíčka na tejto adrese',
  },
  addToTest: {
    id: 'lessonDetail.page.addToTest',
    defaultMessage: 'Pridať do testu',
  },
  createHomework: {
    id: 'lessonDetail.page.createHomework',
    defaultMessage: 'Zadať úlohu žiakom',
  },
  relatedLessons: {
    id: 'lessonDetail.page.relatedLessons',
    defaultMessage: 'Ďalšie cvičenia',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/LessonDetailPage.js